export default "__VITE_ASSET__CgPZ$9Kz__"